import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import ClubAfiliacionesConfig from "../../components/clubAfiliacionesConfig";

interface Props {
  userContext: { clubSessionId: any };
}

class ClubAfiliacionesConfigPage extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Configuración de afiliaciones" />
        <Layout>
          <ClubAfiliacionesConfig userContext={this.props.userContext} />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    userContext: user.userContext
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubAfiliacionesConfigPage);
